import { Column, EditType } from '@src/model/table';
import { Address } from '@src/dtos/version.dto';
import React from 'react';
import { AddressGroupCell } from './address-group-cell';
import { AddressRuleCell } from './address-rule-cell';
import { useStores } from '../../../store';
import {
    isValueDuplicate,
    MAX_NAME_LENGTH,
    maxLength,
    nameValidation
} from '@src/utils/validationUtils';
import { addressesInGroup } from '@src/utils/versionUtils';
import { AddressGroupInfoTooltip } from './address-group-info-tooltip';
import { DisplayNameCell } from '../inventory-utils';
import {
    createDescriptionColumn,
    createIPAddressColumn,
    createIPTypeColumn
} from '@src/components/shared/table/column-factories';

export const useAddressColumns = () => {
    const {fwVersionStore, customerStore} = useStores();
    return [
        {
            accessor: 'displayName',
            header: 'Name',
            width: '250px',
            displayOnEdit: true,
            type: EditType.Text,
            getPlaceholder: () => 'Enter name',
            getDisplayElement: (column, row) => <DisplayNameCell displayName={row.displayName} />,
            mandatory: true,
            maxLength: MAX_NAME_LENGTH,
            validationRules: [isValueDuplicate, maxLength(MAX_NAME_LENGTH),
                (value) => nameValidation(value)]
        },
        {
            ...createIPTypeColumn(),
            isHidden: true,
        },
        {
            ...createIPAddressColumn(customerStore, 350),
            header: `IP Address (${fwVersionStore.selectedFwVersion?.content.policy.addresses.length || 0})`,
        },
        {
            accessor: 'associatedAddressGroupList',
            header: 'Groups',
            width: '300px',
            displayOnEdit: true,
            type: EditType.CustomDropdown,
            getPlaceholder: () => 'Select Address Groups',
            selectProps: {mode: 'multiple', showSearch: true, showArrow: true, maxTagCount: 'responsive'},
            options: () => fwVersionStore.getAddressGroups.map(group => ({label: `${group.displayName} (${addressesInGroup(group).length})`, value: group.displayName})),
            dropdownInfoContent: (displayName: string) => <AddressGroupInfoTooltip displayName={displayName} />,
            mandatory: false,
            getDisplayElement: (column, row) => <AddressGroupCell addressData={row}/>
        },
        {
            accessor: 'id',
            header: 'Rules',
            width: '300px',
            displayOnEdit: false,
            getDisplayElement: (column, row) => <AddressRuleCell addressData={row}/>
        },
        createDescriptionColumn(300)
    ] as Column<Address>[];
};
